export default function decorateName(value) {
    let name = value.replace(/^[ 0-9\\.\\-]*/, '');
    let pattern  = /\[.*?\]/g
    return name.replace(pattern, '');
}